import type { SvgConfig } from '../Svg'

export function SpinTheWheelSvg({ headline = '' }: SvgConfig) {
  return (
    <svg viewBox="0 0 200 200">
      <rect width="100%" height="100%" fill="#FFD200" />

      <defs>
        <path
          id="text-path"
          d="
        M100,20
        A80,80 0 0,1 180,100
        A80,80 0 0,1 100,180
        A80,80 0 0,1 20,100
        A80,80 0 0,1 100,20
      "
        />
      </defs>

      <circle cx="100" cy="100" r="100" fill="white" />

      <text fontSize="18px">
        <textPath href="#text-path">{headline}</textPath>
      </text>
    </svg>
  )
}
